import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { inchesToCentimeters, poundsToMetric } from '../../utils/conversion';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
// import { deepMerge } from '../../utils/object';
// import { urlify } from '../../utils/string';
import s from './ProductDetails.scss';

const ProductDetails = ({ setup, product, variants, variant, cachedProduct, technicalDownloads, bottom = false }) => {
	// Expand/collapse product attributes.
	const [infoSection, setInfoSection] = useState('product-description');

	/* Extract relevant downloads */
	/*
	const downloads = (technicalDownloads.children && Object.keys(technicalDownloads.children).filter((collection) => (
		urlify(product.productType).replace(/[-_]/g, '').toLowerCase().indexOf(collection.replace(/[-_]/g, '').toLowerCase()) !== -1
		|| collection.toLowerCase() === 'general'
	)).reduce((acc, collection) => deepMerge(acc, technicalDownloads.children[collection]), {})) || {};
	const sortOrder = ['pressRelease', 'pressImages', '3dModels', '3dModels-BenchesDaybedsShelves', '3dModels-HighTables', '3dModels-Tables', 'productCertificatesandCompliance', 'productLiterature', 'careandWarranty'];
	*/
	let market = setup?.market;
	if (typeof market === 'number') market = String(typeof setup.market);
	if (!Array.isArray(market)) market = [market];
	const isEu = market.indexOf('65580597415') !== -1;

	const toggleInfoSection = (e) => {
		e.preventDefault();
		const section = e.currentTarget.getAttribute('href').replace('#toggle-', '');
		setInfoSection((prevState) => (prevState === section ? null : section));
	};

	/*
	const recursiveDownloadLinks = (section, id) => {
		if (section.files.length === 0 && Object.keys(section.children).length === 0) return null;
		return (
			<div key={id} className={s.productDetails_infoSection_content_item}>
				{ section.files && section.files.length > 0 && <h5 className={s.productDetails_infoSection_content_item_title}>{ section.name }</h5> }
				<div key={id} className={s.productDetails_infoSection_content_item_files}>
					{
						section.files && section.files.map((file) => (
							<a key={file.link} className={[s.productDetails_infoSection_content_item_file, (/\.(rfa|dwg)$/.test(file.name) ? s.productDetails_infoSection_content_item_file__3d : s.productDetails_infoSection_content_item_file__pdf)].join(' ')} href={file.link.replace('.pdf?dl=1', '.pdf?dl=0')} target="_blank" rel="noopener noreferrer">
								{ file.name.replace(/(^emeco)?[_-]/ig, ' ').replace(/\.[^.]*$/, '').trim() }
							</a>
						))
					}
					{
						Object.keys(section.children).length > 0 && Object.keys(section.children).sort((a, b) => {
							const sortA = sortOrder.indexOf(a) === -1 ? 1e6 : sortOrder.indexOf(a);
							const sortB = sortOrder.indexOf(b) === -1 ? 1e6 : sortOrder.indexOf(b);
							if (sortA > sortB) return 1;
							if (sortA < sortB) return -1;
							return a.localeCompare(b);
						}).map((reccurringSection) => recursiveDownloadLinks(section.children[reccurringSection], reccurringSection))
					}
				</div>
			</div>
		);
	};
	*/

	return (
		<div className={[s.productDetails, (bottom ? s.productDetails__bottom : null)].join(' ')}>
			{ bottom && <h3 className={s.productDetails_title}>{ `${product.title}${cachedProduct.collection.indexOf('by') !== -1 ? ` ${cachedProduct.collection.slice(cachedProduct.collection.indexOf('by'))}` : ''}` }</h3> }
			<div className={[s.productDetails_infoSections, (!variants || variants.length === 1 ? s.productDetails_infoSections__noVariants : null)].join(' ')}>
				{
					product.descriptionHtml && (
						<div className={[s.productDetails_infoSection, (infoSection === 'product-description' ? s.productDetails_infoSection__expanded : null)].join(' ')}>
							<a className={s.productDetails_infoSection_link} href="#toggle-product-description" onClick={toggleInfoSection}>
								<h4 className={s.productDetails_infoSection_title}>{ translate(setup, 'productDescription') }</h4>
							</a>
							<div className={[s.productDetails_infoSection_content, s.productDetails_infoSection_content__raw].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(product.descriptionHtml, {}, setup) }} />
						</div>
					)
				}
				<div className={[s.productDetails_infoSection, (infoSection === 'technical-specifications' ? s.productDetails_infoSection__expanded : null)].join(' ')}>
					<a className={s.productDetails_infoSection_link} href="#toggle-technical-specifications" onClick={toggleInfoSection}>
						<h4 className={s.productDetails_infoSection_title}>{ translate(setup, 'technicalSpecifications') }</h4>
					</a>
					<div className={s.productDetails_infoSection_content}>
						{
							variant?.metafields?.width && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specWidth') }</span>
									<span>{ `${variant.metafields.width}" / ${inchesToCentimeters(variant.metafields.width)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.diameter && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specDiameter') }</span>
									<span>{ `${variant.metafields.diameter}" / ${inchesToCentimeters(variant.metafields.diameter)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.depth && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specDepth') }</span>
									<span>{ `${variant.metafields.depth}" / ${inchesToCentimeters(variant.metafields.depth)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.height && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specHeight') }</span>
									<span>{ `${variant.metafields.height}" / ${inchesToCentimeters(variant.metafields.height)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.seatDepth && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specSeatDepth') }</span>
									<span>{ `${variant.metafields.seatDepth}" / ${inchesToCentimeters(variant.metafields.seatDepth)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.seatHeight && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specSeatHeight') }</span>
									<span>{ `${variant.metafields.seatHeight}" / ${inchesToCentimeters(variant.metafields.seatHeight)}cm` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.armHeight && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specArmHeight') }</span>
									<span>{ `${variant.metafields.armHeight}" / ${inchesToCentimeters(variant.metafields.armHeight)}cm` }</span>
								</div>
							)
						}
						{
							variant?.weight && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specWeight') }</span>
									<span>{ `${variant.weight}lb${parseInt(variant.weight, 10) > 1 ? 's' : ''} / ${poundsToMetric(variant.weight)}` }</span>
								</div>
							)
						}
						{
							variant?.metafields?.stacks && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specStacks') }</span>
									<span>{ variant.metafields.stacks }</span>
								</div>
							)
						}
						{
							variant?.metafields?.shape && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specShape') }</span>
									<span>{ variant.metafields.shape }</span>
								</div>
							)
						}
						{
							variant?.metafields?.material && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specMaterial') }</span>
									<span>{ variant.metafields.material }</span>
								</div>
							)
						}
						{
							variant?.metafields?.colorCode && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specColorCode') }</span>
									<span>{ variant.metafields.colorCode }</span>
								</div>
							)
						}
						{
							((!isEu && variant?.metafields?.leadTime) || (isEu && !variant?.metafields?.leadTimeEu)) && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specLeadTime') }</span>
									<span>{ variant.metafields.leadTime }</span>
								</div>
							)
						}
						{
							isEu && variant?.metafields?.leadTimeEu && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specLeadTime') }</span>
									<span>{ variant.metafields.leadTimeEu }</span>
								</div>
							)
						}
						{
							variant?.metafields?.carbonFootprint && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specCarbonFootprint') }</span>
									<span>{ variant.metafields.carbonFootprint }</span>
								</div>
							)
						}
						{
							variant?.metafields?.warranty && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specWarranty') }</span>
									<span>{ variant.metafields.warranty }</span>
								</div>
							)
						}
						{
							<div className={s.productDetails_infoSection_content_item}>
								<span>{ translate(setup, 'specOutdoorUse') }</span>
								<span>{ variant?.metafields?.outdoorUse ? variant.metafields.outdoorUse : translate(setup, 'specOutdoorUseUnsuitable') }</span>
							</div>
						}
						{
							<div className={s.productDetails_infoSection_content_item}>
								<span>{ translate(setup, 'specFireRetardant') }</span>
								<span>{ variant?.metafields?.fireRetardant ? variant.metafields.fireRetardant : translate(setup, 'specFireRetardantUnsuitable') }</span>
							</div>
						}
						{
							variant?.metafields?.strengthStability && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specStrengthStability') }</span>
									<span>{ variant.metafields.strengthStability }</span>
								</div>
							)
						}
						{
							variant?.metafields?.shippingBox1 && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specShippingBox1') }</span>
									<span>{ variant.metafields.shippingBox1 }</span>
								</div>
							)
						}
						{
							variant?.metafields?.shippingBox2 && (
								<div className={s.productDetails_infoSection_content_item}>
									<span>{ translate(setup, 'specShippingBox2') }</span>
									<span>{ variant.metafields.shippingBox2 }</span>
								</div>
							)
						}
						{
							<div className={s.productDetails_infoSection_content_item}>
								<span>{ translate(setup, 'specRequiresAssembly') }</span>
								<span>{ variant?.metafields?.requiresAssembly ? translate(setup, 'specRequiresAssemblyTrue') : translate(setup, 'specRequiresAssemblyFalse') }</span>
							</div>
						}
					</div>
				</div>
				<div className={[s.productDetails_infoSection, (infoSection === 'downloads' ? s.productDetails_infoSection__expanded : null)].join(' ')}>
					<a className={s.productDetails_infoSection_link} href={`https://emeco.presscloud.com/digitalshowroom/#/gallery/${cachedProduct.collection.replace('&', 'and').replace(/\s/g, '-')}`} target="_blank" rel="noopener noreferrer nofollow">
						<h4 className={s.productDetails_infoSection_title}>{ translate(setup, 'downloads') }</h4>
					</a>
				</div>
				{/*
					Object.keys(downloads).length > 0 && (
						<div className={[s.productDetails_infoSection, (infoSection === 'downloads' ? s.productDetails_infoSection__expanded : null)].join(' ')}>
							<a className={s.productDetails_infoSection_link} href="#toggle-downloads" onClick={toggleInfoSection}>
								<h4 className={s.productDetails_infoSection_title}>{ translate(setup, 'downloads') }</h4>
							</a>
							<div className={s.productDetails_infoSection_content}>
								{
									Object.keys(downloads.children).sort((a, b) => {
										const sortA = sortOrder.indexOf(a) === -1 ? 1e6 : sortOrder.indexOf(a);
										const sortB = sortOrder.indexOf(b) === -1 ? 1e6 : sortOrder.indexOf(b);
										if (sortA > sortB) return 1;
										if (sortA < sortB) return -1;
										return a.localeCompare(b);
									}).map((section) => recursiveDownloadLinks(downloads.children[section], section))
								}
							</div>
						</div>
					)
				*/}
			</div>
		</div>
	);
};

export default hot(module)(ProductDetails);
